import { useMemo } from 'react';
import { keyBy, compact, some } from 'lodash';
import { TELCO_CHANNELS } from '../constants';
import { EXCLUDED_SEARCH_CHANNELS } from 'data/audience-channels';

const useAudienceConfig = ({ propsAudienceChannel, propsSegment, context, abiPermissions }) => {
  const audienceChannel = useMemo(
    () => propsAudienceChannel || context.current.audience_app.current_channel.value,
    [propsAudienceChannel, context]
  );

  const segment = useMemo(
    () => propsSegment || context.current.audience_app[audienceChannel].audience_segment,
    [propsSegment, context, audienceChannel]
  );

  const isFirstParty = useMemo(() => some(segment, { type: '1st party' }), [segment]);

  const includeSearches = useMemo(
    () =>
      abiPermissions.hasPermission(['search']) &&
      !isFirstParty &&
      !TELCO_CHANNELS.includes(audienceChannel) &&
      !EXCLUDED_SEARCH_CHANNELS.includes(audienceChannel),
    [abiPermissions, isFirstParty, audienceChannel]
  );

  const interestTypes = useMemo(
    () =>
      compact([
        { value: 'websites', label: 'Websites', plural: 'websites', singular: 'website' },
        { value: 'phrases', label: 'Phrases', plural: 'phrases', singular: 'phrase' },
        includeSearches && { value: 'searches', label: 'Searches', plural: 'searches', singular: 'search term' },
      ]),
    [includeSearches]
  );

  const interestTypesMap = useMemo(() => keyBy(interestTypes, 'value'), [interestTypes]);

  const targetRatio = context.current.audience_segment_target_ratio;
  const targetRatioObj = targetRatio ? { 'wanted-intenders-ratio': targetRatio } : undefined;

  return {
    audienceChannel,
    segment,
    isFirstParty,
    includeSearches,
    interestTypes,
    interestTypesMap,
    targetRatioObj,
  };
};

export default useAudienceConfig;
